/**
 * Navigation Handler for API Client
 * 
 * This module provides a way to handle navigation from non-React contexts
 * (like apiClient) using React Router's navigate function.
 */

type NavigateFunction = (to: string, options?: { replace?: boolean }) => void;

let navigateHandler: NavigateFunction | null = null;

/**
 * Initialize the navigation handler with React Router's navigate function
 * Should be called once from App.tsx or root component
 */
export const setNavigateHandler = (navigate: NavigateFunction): void => {
  navigateHandler = navigate;
};

/**
 * Navigate to a route using React Router if available, otherwise fall back to window.location
 */
export const navigateTo = (path: string, options?: { replace?: boolean }): void => {
  // Prevent navigation if we're already on the target path (avoids unnecessary re-renders)
  if (window.location.pathname === path) {
    return;
  }
  
  if (navigateHandler) {
    navigateHandler(path, options);
  } else {
    // Fallback for cases where navigate handler hasn't been initialized yet
    // This should rarely happen, but provides backward compatibility
    if (options?.replace) {
      window.location.replace(path);
    } else {
      window.location.href = path;
    }
  }
};

